import { Navigate, createFileRoute } from "@tanstack/react-router";
import { useAppSelector } from "../store";
import { LoginPage } from "./login/-LoginPage";

export const Route = createFileRoute("/login")({
  component: LoginRoute,
});

function LoginRoute() {
  const isAuthenticated = useAppSelector((state) => state.auth.isAuthenticated);

  if (isAuthenticated) {
    return <Navigate to="/media" />;
  }

  return <LoginPage />;
}
